import React from 'react';
import Plasma from '../assets/img/XHMJINPB0JW.png';
import Orthopedic from '../assets/img/shutterstock_62766982.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function TheraSorb() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="news-content">
                                    <p className='mb-3'>
                                        <span className='font-weight-bold'>One platform for therapeutic plasma exchange (TPE) and selective removal of:</span> 
                                    </p>
                                    <p className='mb-3'>
                                        </p><ul>
                                            <li className='li-arrow'>immunoglobulins</li>
                                            <li className='li-arrow'>LDL cholesterol and lipoprotein(a)</li>
                                            <li className='li-arrow'>fibrin, fibrinogen, and fibrin degradation products</li>
                                        </ul>
                                    <p className='mb-3'></p>
                                    <p className='mb-3'>
                                        The TheraSorb™ Therapeutic Apheresis system is based on the selective removal of pathogenic substances from the patient’s plasma. 
                                    </p>
                                    <p className='mb-3'>
                                        During apheresis, target molecules are selectively removed while the plasma is reinfused into the patient. Hence, higher plasma volumes can be processed than in therapeutic plasma exchange. Since no substitution fluid is required, the treatment is usually very well tolerated.
                                    </p>
                                    <p className='mb-3'>
                                        TheraSorb Products may be helpful for the treatment of diseases associated with hypercholesterolemia, pathogenic immunoglobulins, and fibrinogen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default TheraSorb;
